import { Temporal } from "@js-temporal/polyfill";

export interface Position {
    id: number;
    name: string;
    startDate: Temporal.PlainDate;
    endDate: Temporal.PlainDate;

    description: string;
    profilesDescription: string;
    groupKey?: string;
    companyId?: number;
}

export class PositionModel implements Position {
    id: number;
    name = '';
    startDate: Temporal.PlainDate;
    endDate: Temporal.PlainDate;

    description = '';
    profilesDescription = '';
    groupKey = '';
    companyId = null;
}